export default __webpack_public_path__ + "static/depositNFT_dark-a73ea1f822dbae4374a04ef0fd71ab16.png";